import { InfoPlateVariant } from "fe-shared/src/components";
import {
  InvoiceStatusCode,
  TransactionType,
} from "fe-shared-transactions/src/types";

import { InventoryAdjustmentStatusCode } from "./types/inventoryAdjustments";

export const TRANSACTIONS_QUERY_KEY = "transactions";
export const TRANSACTION_ACTIVITIES_QUERY_KEY = "transactionActivities";
export const TRANSACTIONS_NAVIGATION_QUERY_KEY = "transactionsNavigation";
export const TRANSACTION_DETAILS_PORTAL_ID = "transaction-details-action-warning";
export const TRANSACTION_LINKED_TO_ORIGINAL = "linkedOriginalTransaction";
export const TRANSACTION_LINKED_TO_ADJUSTMENT = "linkedAdjustmentTransaction";
export const TRANSACTION_LIST_INFO_QUERY_KEY = "transactionListInfo";

export const CORRECTIONS_QUERY_KEY = "corrections";

export const TRANSFERS_QUERY_KEY = "transfers";
export const TRANSFERS_ACTIVITIES_QUERY_KEY = "transfersActivities";

export const INVOICES_QUERY_KEY = "invoices";
export const INVOICES_ACTIVITIES_QUERY_KEY = "invoicesActivities";
export const INVOICES_NAVIGATION_QUERY_KEY = "invoicesNavigation";
export const INVOICES_LISTINFO_QUERY_KEY = "invoicesListInfo";

export const INVENTORY_ADJUSTMENTS_QUERY_KEY = "inventoryAdjustments";
export const INVENTORY_ADJUSTMENTS_ACTIVITIES_QUERY_KEY = "inventoryAdjustmentsActivities";
export const INVENTORY_ADJUSTMENTS_NOTES_QUERY_KEY = "inventoryAdjustmentsNotes";

export const PAGE_SIZE = 20;
export const NAVIGATION_PAGE_SIZE = 100;
export const NAVIGATION_REQUESTS_LIMIT = 10;

export const COMMENT_LENGTH_LIMIT = 2000;
export const FLAG_LENGTH_LIMIT = 250;

export const FLAG_COLOR = "#E64040";
export const WARNING_COLOR = "#F2A033";

export const PERMISSIONS = {
  transactionsList: "TransactionManagement.TransactionList",
  transactionListAssign: "TransactionList.AssignTransaction",
  transactionDetailsAssign: "TransactionList.AssignTransaction",
  transactionsListExport: "TransactionList.ExportTransactionList",
  transactionListPictusExport: "TransactionList.ExportPictusJson",
  transactionsListCreateRetreadingTransaction:
    "TransactionList.CreateRetreadingTransaction",
  transactionDetails: "TransactionManagement.TransactionDetailsPage",
  transactionNotes: "TransactionDetailsPage.SeeNotes",
  transactionAddNote: "TransactionDetailsPage.AddNotes",
  transactionNotesExport: "TransactionDetailsPage.ExportNotes",
  transactionHistoryExport: "TransactionDetailsPage.ExportHistory",
  transactionHistory: "TransactionDetailsPage.SeeHistory",
  transactionManualFlagging: "TransactionDetailsPage.ManualFlaggingTransaction",
  transactionEditManualFlag: "TransactionDetailsPage.EditManualFlag",
  transactionUnflag: "TransactionDetailsPage.UnflagTransaction",
  transactionReturn: "TransactionDetailsPage.ReturnTransaction",
  transactionCorrect:
    "TransactionDetailsPage.CorrectTransactionTiresSubSection",
  transactionCorrectionSubmit: "TransactionDetailsPage.SubmitCorrections",
  transactionInvalidation: "TransactionDetailsPage.InvalidateTransaction",
  transactionRevert: "TransactionDetailsPage.RestoreTransaction",
  transactionApproveFirstLevel:
    "TransactionDetailsPage.1stTransactionApprovalLevel",
  transactionApproveSecondLevel:
    "TransactionDetailsPage.2ndTransactionApprovalLevel",
  transactionAdjustmentCreate:
    "TransactionDetailsPage.CreateAdjustmentTransaction",
  transactionAdjustmentApproveFirstLevel:
    "TransactionDetailsPage.1stAdjustmentApprovalLevel",
  transactionAdjustmentApproveSecondLevel:
    "TransactionDetailsPage.2ndAdjustmentApprovalLevel",
  transactionAdjustmentInvalidate:
    "TransactionDetailsPage.InvalidateAdjustment",
  transactionAdjustmentRestore: "TransactionDetailsPage.RestoreAdjustment",
  transactionDispositionEdit:
    "TransactionDetailsPage.CorrectTransactionTiresSubSection",
  transactionRetreadingEdit:
    "TransactionDetailsPage.UpdateRetreadingTransaction",
  transactionSeeTraceability: "TransactionDetailsPage.SeeTraceability",
  transfersList: "Portal.StorageTransfersMenu",
  transfersDetails: "StorageTransfersMenu.TransferDetailsPage",
  transfersListExport: "Portal.StorageTransfersMenu",
  transferNotesExport: "StorageTransfersMenu.TransferDetailsPage",
  transferAddNote: "StorageTransfersMenu.TransferDetailsPage",
  transferNotes: "StorageTransfersMenu.TransferDetailsPage",
  transferHistoryExport: "StorageTransfersMenu.TransferDetailsPage",
  transferHistory: "StorageTransfersMenu.TransferDetailsPage",
  transferUploadAndRemoveFiles: "StorageTransfersMenu.TransferDetailsPage",
  transferCancel: "StorageTransfersMenu.TransferDetailsPage",
  transferInvalidate: "TransferDetailsPage.InvalidateTransfer",
  transferAssign: "TransferDetailsPage.AssignTransfer",
  transferApprove: "TransferDetailsPage.ApproveTransfer",
  invoicesList: "Invoice.SeeInvoiceList",
  invoicesListExport: "Invoice.SeeInvoiceList",
  invoiceDetails: "Invoice.ReviewInvoiceDetails",
  invoiceAssign: "SeeInvoiceList.AssignInvoiceFromInvoiceList",
  invoiceDetailsAssign: "ReviewInvoiceDetails.AssignInvoiceFromInvoiceDetails",
  invoiceHistory: "ReviewInvoiceDetails.SeeInvoiceHistoryLogs",
  invoiceHistoryExport: "ReviewInvoiceDetails.ExportInvoiceHistoryLogs",
  invoiceNotes: "ReviewInvoiceDetails.SeeListOfNotes",
  invoiceAddNote: "ReviewInvoiceDetails.AddNewNote",
  invoiceNotesExport: "ReviewInvoiceDetails.ExportNotes",
  invoiceAdjust: "ReviewInvoiceDetails.AdjustInvoice",
  invoiceApproveClerkLevel: "ReviewInvoiceDetails.ApproveInvoiceClerkLevel",
  invoiceApproveManagerLevel: "ReviewInvoiceDetails.ApproveInvoiceManagerLevel",
  invoiceApproveDirectorLevel: "ReviewInvoiceDetails.ApproveInvoiceDirectorLevel",
  invoiceApproveExecutiveLevel: "ReviewInvoiceDetails.ApproveInvoiceExecutiveLevel",
  invoiceApproveCEOLevel: "ReviewInvoiceDetails.ApproveInvoiceCEOLevel",
  invoicePostToGP: "ReviewInvoiceDetails.PostInvoiceToGP",
  transactionOverrideRegulatoryYear:
    "TransactionDetailsPage.OverrideRegulatoryYear",
  transactionUpdateClaimNumber:
    "TransactionDetailsPage.UpdateClaimNumber",
  transactionUpdateTrailerNumber:
    "TransactionDetailsPage.UpdateTrailerNumber",
  inventoryAdjustmentsList: "Portal.InventoryAdjustmentsList",
  inventoryAdjustmentsDetails:
    "InventoryAdjustmentsList.ViewInventoryAdjustmentDetails",
  inventoryAdjustmentsListExport:
    "InventoryAdjustmentsList.ExportInventoryAdjustmentsList",
  inventoryAdjustmentsListNotes: "ViewInventoryAdjustmentDetails.ViewNotes",
  inventoryAdjustmentsListAddNote: "ViewInventoryAdjustmentDetails.AddNotes",
  inventoryAdjustmentsListNotesExport:
    "ViewInventoryAdjustmentDetails.ExportNotes",
  inventoryAdjustmentsListHistoryExport:
    "ViewInventoryAdjustmentDetails.ExportHistory",
  inventoryAdjustmentsListHistory: "ViewInventoryAdjustmentDetails.ViewHistory",
  inventoryAdjustmentsAssign:
    "InventoryAdjustmentsList.AssignInventoryAdjustment",
  inventoryAdjustmentsBulkAssign:
    "InventoryAdjustmentsList.BulkAssignInventoryAdjustments",
  inventoryAdjustmentsEdit:
    "ViewInventoryAdjustmentDetails.EditInventoryAdjustment",
  inventoryAdjustmentsInvalidate:
    "ViewInventoryAdjustmentDetails.InvalidateInventoryAdjustment",
  inventoryAdjustmentsApproveFirstLevel:
    "ViewInventoryAdjustmentDetails.InventoryAdjustmentPreApproval",
  inventoryAdjustmentsApproveSecondLevel:
    "ViewInventoryAdjustmentDetails.InventoryAdjustmentSignOff",
  transactionCreateReceipt: "TransactionDetailsPage.CreateReceipt",
  transactionEditTireTypeWeights: "TransactionDetailsPage.EditTireTypeWeights",
  requestDetails: "PickupRequests.PickupRequestDetails",
};

export const INVOICE_APPROVAL_ROLES = {
  InvoiceApprovalCEO: "InvoiceApprovalCEO",
  InvoiceApprovalExecutive: "InvoiceApprovalExecutive",
  InvoiceApprovalDirector: "InvoiceApprovalDirector",
  InvoiceApprovalManager: "InvoiceApprovalManager",
  InvoiceApprovalClerk: "InvoiceApprovalClerk",
};

export const GP_SYNC_ROLES = {
  FinanceClerk: "FinanceClerk",
};

export type InvoiceStatusesConfigMap = {
  [key in InvoiceStatusCode]?: InfoPlateVariant;
};

export const INVOICE_STATUSES_CONFIG_MAP: InvoiceStatusesConfigMap = {
  [InvoiceStatusCode.Submitted]: "neutral",
  [InvoiceStatusCode.InReview]: "warning",
  [InvoiceStatusCode.InApproval]: "warning",
  [InvoiceStatusCode.Approved]: "active",
};

export type InventoryAdjustmentConfigMap = {
  [key in InventoryAdjustmentStatusCode]?: InfoPlateVariant;
};

export const INVENTORY_ADJUSTMENT_STATUSES_CONFIG_MAP: InventoryAdjustmentConfigMap = {
  [InventoryAdjustmentStatusCode.Submitted]: "neutral",
  [InventoryAdjustmentStatusCode.InReview]: "warning",
  [InventoryAdjustmentStatusCode.Reviewed]: "orange",
  [InventoryAdjustmentStatusCode.Approved]: "active",
  [InventoryAdjustmentStatusCode.Invalid]: "error",
};

export const TRANSACTION_ADJUSTMENT_APPLICABLE_TYPES: TransactionType[] = [
  TransactionType.Pickup,
  TransactionType.Delivery,
  TransactionType.Shipment,
  TransactionType.Receipt,
];
